import { Flex } from '@chakra-ui/react';
import DefaultLayout from '@components/layout/layout/DefaultLayout';
import { antlerStyle } from '@constants/styles';
import PlanSatisfactionSurvey from '../components/surveys';

const Survey = () => (
  <DefaultLayout>
    <Flex px={antlerStyle.px} py={[12, 12, 24, '60px']} bg="darkBackground" w="100%">
      <Flex minH="100vh" py="12" px={[2, 6, '3%', '3%', '5%']}>
        <PlanSatisfactionSurvey />
      </Flex>
    </Flex>
  </DefaultLayout>
);

export default Survey;
